import { $httpChangiRecommends } from '@/core/api';
const state = {
    orders: [],
    orderLast: [],
    orderDetails: [],
    loaded: false,
    loading: false,
    currentPage: 1,
    currentUuid: '',
};
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setLoaded(state, loaded) {
        state.loaded = loaded;
    },
    setOrders(state, orders) {
        state.orders = orders;
    },
    setOrderLast(state, orderLast) {
        state.orderLast = orderLast;
    },
    setPage(state, page) {
        state.currentPage = page;
    },
    setOrderDetails(state, orderDetails) {
        state.orderDetails = orderDetails;
    },
    setCurrentUuid(state, currentUuid) {
        state.currentUuid = currentUuid;
    },
};
const actions = {
    getOrders({ state, commit }, salesChannelKey) {
        commit('setLoading', true);
        $httpChangiRecommends.api
            .ChangiRecommendsDashboardOrdersList({ page: state.currentPage, salesChannelKey: salesChannelKey })
            .then((items) => {
            console.log(items);
            commit('setOrders', items.data);
            commit('setLoaded', true);
        })
            .catch((err) => {
            commit('setLoaded', false);
            console.log(err);
        })
            .finally(() => commit('setLoading', false));
    },
    getOrderLast({ commit }) {
        commit('setLoading', true);
        $httpChangiRecommends.api
            .ChangiRecommendsDashboardOrderLast()
            .then((items) => {
            commit('setOrderLast', items.data);
            commit('setLoaded', true);
        })
            .catch((err) => {
            commit('setLoaded', false);
            console.log(err);
        })
            .finally(() => commit('setLoading', false));
    },
    getOrderDetails({ state, commit }, orderUuid) {
        commit('setLoading', true);
        $httpChangiRecommends.api
            .ChangiRecommendsDashboardOrderView(orderUuid)
            .then((items) => {
            console.log(items.data[0]);
            commit('setOrderDetails', items.data[0]);
            commit('setLoaded', true);
        })
            .catch((err) => {
            commit('setLoaded', false);
            console.log(err);
        })
            .finally(() => commit('setLoading', false));
    },
};
export const orderModule = {
    state,
    mutations,
    actions,
    namespaced: true,
};
